import { render, staticRenderFns } from "./videoConfSectionHeader.vue?vue&type=template&id=1ff51b00&scoped=true&lang=pug&"
import script from "./videoConfSectionHeader.vue?vue&type=script&lang=js&"
export * from "./videoConfSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./videoConfSectionHeader.vue?vue&type=style&index=0&id=1ff51b00&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff51b00",
  null
  
)

export default component.exports